export default {
  data() {
    return {
      benefits:
        typeof this.$t('globals.RegistrationBenefits') === 'object' &&
        this.$t('globals.RegistrationBenefits').length > 0
          ? this.$t('globals.RegistrationBenefits')
          : [],
    }
  },
}
